export const PAYMENT_METHOD = {
  DEBIT: 'debit',
  CREDIT: 'credit',
} as const;

export type PaymentMethod = (typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD];

export const PAYMENT_STATUS = {
  CREATED: 'Created',
  SENT: 'Sent',
  VIEWED: 'Viewed',
  CONFIRMED: 'Confirmed',
  PAID: 'Paid',
  COMPLETE: 'Complete',
  VOIDED: 'Voided',
  // add more stauses here as needed
} as const;

export type PaymentStatus = (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];
